import React, { useState, useRef, useEffect  } from 'react';
import { Form, Input, Select, Button, Row, Col, notification, Modal } from 'antd';
import { projectStacks } from '../../services/cs-lab-config';
import { generateAiQuestion, getQueueResult } from '../../services/ide-apis';
import { getIdeProjectTypeMetaData, trackEvent } from '../utils/util-functions';
import { ReactComponent as AiIconWhite } from '../../assets/logos/ai icon white.svg';
// // import { ReactComponent as QuestionMark } from '../../assets/logos/question mark.svg';
import AiGeneratingModal from '../labAssignments/aiGenerating-modal'; 
import AiGeneratedResultModal from '../labAssignments/ai-generated-result-modal'; 
import ClassRoomMasterLoader from '../common/classroom-master-loader';

const { Option } = Select;
const AiQuestionsModal = ({
  isModalOpen,
  onCancel,
  handleAiQuestionData,
  selectedProject,
  grade,
  topic,
  additionalInfo,
  setSelectedProject,
  setGrade,
  setTopic,
  setAdditionalInfo
 }) => {

    // const { Option } = Select;
    const [isLoading, setIsLoading] = useState(false);
    const [isResultOpen, setIsResultOpen] = useState(false);
    const [aiQuestionData, setAiQuestionData] = useState(null);
    const [aiForm] = Form.useForm();
    const intervalRef = useRef(null);


    useEffect(() => {
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, []);

    const handleModalClose = () => {
        aiForm.resetFields();
        setSelectedProject('default');
        setGrade(null);
        setTopic('');
        setAdditionalInfo('');
        onCancel(); 
    };
    const handleRegeneratedData = (newData) => {
        setAiQuestionData(newData);
        setIsResultOpen(true); // reopen AiGeneratedResultModal with new regenerated data
    };

    const fnGenerateAiQuesion = async () => {
        try {

            if (!selectedProject) {
                return notification.error({
                    message: 'Error',
                    description: 'Please select a project type',
                });

            }

            if (!grade) {
                return notification.error({
                    message: 'Error',
                    description: 'Please select a grade',
                });
            }

            if (!topic) {
                return notification.error({
                    message: 'Error',
                    description: 'Please select topic',
                });
            }

            const reqObj = {
                "subject": selectedProject,
                "grade": grade,
                "topic": topic
            };

            if (additionalInfo) {
                reqObj.additionalInstruction = additionalInfo;
            }
            onCancel();
            handleModalClose();
            setIsLoading(true);
            trackEvent('generate_ai_question_button_clicked', {
                from: 'csLab',
                ide_project_stack_name: selectedProject,
                grade,
                topic
            });

            const response = await generateAiQuestion(reqObj);

            if (response.data.statusCode === 200 && response.data.queueId) {

                let count = 20;
                intervalRef.current = setInterval(async () => {
                    try {
                        const res = await getQueueResult(response.data.queueId);
                        if (res.data.statusCode === 200) {
                            setIsLoading(false);
                            clearInterval(intervalRef.current);
                            intervalRef.current = null;
                            if (res.data.response.questionTitle && res.data.response.question) {
                                if (res.data.response.example) {
                                    res.data.response.question = res.data.response.question +  "<br>" + res.data.response.example;
                                }                                
                                const questionObj = { questionTitle: res.data.response.questionTitle, question: res.data.response.question, aiProjectType: selectedProject ,grade: grade, topic: topic}
                                setAiQuestionData(questionObj); 
                                setIsResultOpen(true);

                                notification.success({
                                    message: 'Success',
                                    description: 'AI question generated successfully.',
                                });
                            }
                        } else {
                            count -= 1;
                            if (count === 0) {
                                clearInterval(intervalRef.current);
                                intervalRef.current = null;
                                setIsLoading(false);
                                notification.error({
                                    message: 'Error',
                                    description: 'Failed to generate AI question. Please try again.',
                                });
                            }
                        }
                    } catch (pollingError) {
                        clearInterval(intervalRef.current);
                        intervalRef.current = null;
                        setIsLoading(false);
                        notification.error({
                            message: 'Error',
                            description: 'Failed to fetch AI question result.',
                        });
                    }
                }, 3000);
            } else {
                setIsLoading(false);
                notification.error({
                    message: 'Error',
                    description: 'Failed to generate AI question. Please try again.',
                });
            }

        } catch (error) {
            notification.error({
                message: 'Error',
                description: error.message,
            });
            setIsLoading(false)
        }
    };

    const handleProjectTypeChange = (value) => {
        setSelectedProject(value);
    };

    const handleClassChange = (value, classObj) => {
        setGrade(classObj.className);
    };

    const handleTopicChange = (e) => {
        setTopic(e.target.value);
    };

    const handleAdditionalInfoChange = (e) => {
        setAdditionalInfo(e.target.value);
    };

    return (
        <>
            <Modal
            title="AI Question"
            open={isModalOpen}
            onCancel={handleModalClose} 
            footer={null}
            centered
            destroyOnClose
            >
                <Form layout="vertical" form={aiForm}>
                    <Form.Item
                        label="Project Type*"
                        className="poppins-regular"
                        labelCol={{ className: 'poppins-regular' }}
                    >
                        <Select
                        value={selectedProject}
                        defaultValue="default"
                        onChange={handleProjectTypeChange}
                        >
                        <Option value="default" disabled>
                                        Select a project type
                        </Option>
                        {Object.values(projectStacks)
                            .flatMap((items) =>
                            items
                                .map((item) => ({
                                ...item,
                                metaData: getIdeProjectTypeMetaData(item.projectStackName),
                                }))
                                .filter((item) => item.metaData.showLabQuestion)
                            )
                            .map((item) => (
                            <Option key={item.projectStackName} value={item.projectStackName}>
                                {item.metaData.projectStackDisplayName}
                            </Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label="Grade*"
                        className="poppins-regular"
                        labelCol={{ className: 'poppins-regular' }}
                    >
                        <ClassRoomMasterLoader
                        classId={grade}
                        style={{ width: '100%' }}
                        onChange={handleClassChange}
                        showAllOption={false}
                        selectMultiple={false}
                        loadAllClassRoom={true}
                        fullWidth={true}
                        />
                    </Form.Item>

                    <Form.Item
                        label="Topic*"
                        className="poppins-regular"
                        labelCol={{ className: 'poppins-regular' }}
                    >
                        <Input
                        value={topic}
                        placeholder="Enter topic"
                        onChange={handleTopicChange}
                        />
                    </Form.Item>

                    <Form.Item
                        label="Instructions"
                        className="poppins-regular"
                        labelCol={{ className: 'poppins-regular' }}
                    >
                        <Input.TextArea
                        value={additionalInfo}
                        rows={4}
                        placeholder="Type your instructions to AI here"
                        onChange={handleAdditionalInfoChange}
                        />
                    </Form.Item>

                    <Row justify="end" className="mt-4">
                        <Col span={7}> {/* Adjust the span if needed */}
                            <Button type="primary" onClick={fnGenerateAiQuesion} size="large" disabled={isLoading} style={{ backgroundColor: '#E75C4A', border: 'none' }} >
                                {isLoading ? 'Generating...' : 'Generate'}
                                <AiIconWhite />
                            </Button>
                        </Col>
                    </Row>
                </Form>

            </Modal>
            <AiGeneratingModal open={isLoading} />
            <AiGeneratedResultModal
                open={isResultOpen}
                onCancel={() => {
                    setIsResultOpen(false);
                    handleModalClose();
                }}
                questionData={aiQuestionData}
                onInsert={() => {
                    handleAiQuestionData(aiQuestionData);
                    setIsResultOpen(false);
                  }}
                handleAiQuestionData={handleRegeneratedData}
            />
        </>
    );
};

export default AiQuestionsModal;
